module.exports = __webpack_public_path__ + "img/khavarmiyaneh.6bda69dc.png";